module.exports = __webpack_public_path__ + "img/icon_sm_gdcb.b7c640c1.png";